<app-enfaf-modal
  svgIcon="modal-user"
  title="Nuevo estudiante"
  buttonConfirmText="Crear"
  [isLoading]="isSavingStudent"
  [disableConfirmButton]="studentForm.invalid || isSavingStudent"
  (onClose)="confirmCloseModal()"
  (onConfirm)="saveStudent()"
>
  <form class="student-form" [formGroup]="studentForm" autocomplete="off">
    <enfaf-input
      color="light"
      label="Email"
      name="email"
      placeholder="Email del estudiante"
      [control]="studentForm.controls['email']"
      errorLabel="Email requerido"
    >
    </enfaf-input>

    <div class="student-form__row">
      <enfaf-input
        color="light"
        label="Nombre"
        name="name"
        placeholder="Nombre del estudiante"
        [control]="studentForm.controls['name']"
        errorLabel="Nombre requerido"
      >
      </enfaf-input>
      <enfaf-input
        color="light"
        label="Apellidos"
        name="lastname"
        placeholder="Apellidos del estudiante"
        [control]="studentForm.controls['lastname']"
        errorLabel="Apellidos requeridos"
      >
      </enfaf-input>
    </div>

    <div class="student-form__row">
      <enfaf-country-selector class="light" [countries]="countries" [countryControl]="studentForm.controls['countryId']"></enfaf-country-selector>
      <enfaf-input
        color="light"
        label="Teléfono"
        name="phone"
        placeholder="Teléfono del estudiante"
        [control]="studentForm.controls['phone']"
        errorLabel="Teléfono requerido"
      >
      </enfaf-input>
    </div>
    <enfaf-input
      color="light"
      [label]="data?.requireDni ? 'DNI / NIE / pasaporte' : 'DNI / NIE / pasaporte (opcional)'"
      name="dni"
      placeholder="Documento de identidad del estudiante"
      [control]="studentForm.controls['dni']"
      errorLabel="DNI / NIE / pasaporte requerido (máx. 50 caracteres)"
    >
    </enfaf-input>
    <input type="hidden" formControlName="phonePrefix" />
  </form>
</app-enfaf-modal>
